export interface IJobGrade {
  id: string;
  name: string;
  group: string;
  level: number;
}

export const JOB_GRADES: IJobGrade[] = [
  // Urzędnicze
  { id: "g-01", name: "Referent",                            group: "Urzędnicze",      level: 1 },
  { id: "g-02", name: "Starszy referent",                    group: "Urzędnicze",      level: 2 },
  { id: "g-03", name: "Podinspektor",                        group: "Urzędnicze",      level: 3 },
  { id: "g-04", name: "Inspektor",                           group: "Urzędnicze",      level: 4 },
  { id: "g-05", name: "Starszy inspektor",                   group: "Urzędnicze",      level: 5 },
  { id: "g-06", name: "Specjalista",                         group: "Urzędnicze",      level: 6 },
  { id: "g-07", name: "Starszy specjalista",                 group: "Urzędnicze",      level: 7 },
  { id: "g-08", name: "Główny specjalista",                  group: "Urzędnicze",      level: 8 },
  // Kierownicze
  { id: "g-09", name: "Kierownik referatu",                  group: "Kierownicze",     level: 9 },
  { id: "g-10", name: "Zastępca naczelnika wydziału",        group: "Kierownicze",     level: 10 },
  { id: "g-11", name: "Naczelnik wydziału",                  group: "Kierownicze",     level: 11 },
  { id: "g-12", name: "Zastępca dyrektora departamentu",     group: "Kierownicze",     level: 12 },
  { id: "g-13", name: "Dyrektor departamentu",               group: "Kierownicze",     level: 13 },
  { id: "g-14", name: "Dyrektor generalny urzędu",           group: "Kierownicze",     level: 15 },
  // Organy jst
  { id: "g-15", name: "Sekretarz gminy / powiatu",           group: "Organy JST",      level: 14 },
  { id: "g-16", name: "Skarbnik gminy / powiatu",            group: "Organy JST",      level: 14 },
  { id: "g-17", name: "Zastępca wójta / burmistrza",         group: "Organy JST",      level: 15 },
  { id: "g-18", name: "Wójt / Burmistrz / Prezydent miasta", group: "Organy JST",      level: 16 },
  { id: "g-19", name: "Wicestarosta",                        group: "Organy JST",      level: 15 },
  { id: "g-20", name: "Starosta",                            group: "Organy JST",      level: 16 },
  { id: "g-21", name: "Wicemarszałek województwa",           group: "Organy JST",      level: 16 },
  { id: "g-22", name: "Marszałek województwa",               group: "Organy JST",      level: 17 },
  // Służba cywilna
  { id: "g-23", name: "Pracownik służby cywilnej",           group: "Służba cywilna",  level: 2 },
  { id: "g-24", name: "Urzędnik służby cywilnej",            group: "Służba cywilna",  level: 5 },
  { id: "g-25", name: "Radca",                               group: "Służba cywilna",  level: 7 },
  { id: "g-26", name: "Starszy radca",                       group: "Służba cywilna",  level: 8 },
  // Prawnicze
  { id: "g-27", name: "Aplikant radcowski",                  group: "Prawnicze",       level: 1 },
  { id: "g-28", name: "Aplikant adwokacki",                  group: "Prawnicze",       level: 1 },
  { id: "g-29", name: "Radca prawny",                        group: "Prawnicze",       level: 5 },
  { id: "g-30", name: "Adwokat",                             group: "Prawnicze",       level: 5 },
  { id: "g-31", name: "Notariusz",                           group: "Prawnicze",       level: 6 },
  { id: "g-32", name: "Komornik sądowy",                     group: "Prawnicze",       level: 6 },
];

export const GRADE_GROUPS = [...new Set(JOB_GRADES.map((g) => g.group))];
